import { Schema as S, SchemaTransformation } from "effect";

/** What the client sends: one canonical spelling per entity. */
export const EntityType = S.Literals(["record", "entry"]);

/**
 * What the server returns. It writes `record`/`entry` and still serves rows a
 * pre-migration write left as `node`/`knot`, so responses carry either.
 */
export const StoredEntityType = S.Literals(["record", "entry", "node", "knot"]);

export const normalizeEntityType = (
	value: typeof StoredEntityType.Type,
): typeof EntityType.Type =>
	value === "node" ? "record" : value === "knot" ? "entry" : value;
export const ValueType = S.Literals([
	"string",
	"number",
	"date",
	"boolean",
	"url",
]);
export type ValueType = typeof ValueType.Type;

export const AttributeSchemaEntry = S.Struct({
	id: S.String,
	circleId: S.String,
	entityType: StoredEntityType,
	subType: S.NullOr(S.String),
	key: S.String,
	valueType: ValueType,
	label: S.NullOr(S.String),
	description: S.NullOr(S.String),
	/** `integer().default(0)` without notNull: null is possible, v1 typed it `number`. */
	sortOrder: S.NullOr(S.Number).pipe(
		S.decodeTo(
			S.Number,
			SchemaTransformation.transform({
				decode: (value) => value ?? 0,
				encode: (value) => value,
			}),
		),
	),
	createdAt: S.String,
	updatedAt: S.String,
});
export type AttributeSchemaEntry = typeof AttributeSchemaEntry.Type;

export const AttributeSchemaList = S.Struct({
	data: S.Array(AttributeSchemaEntry),
});
export type AttributeSchemaList = typeof AttributeSchemaList.Type;
